export default __webpack_public_path__ + "static/media/show-visible.0648be69.svg";